<template>
  <table-column :table-id="tableId"></table-column>
</template>

<style scoped>

</style>

<script>
  import TableConfig from "./tableConfig.ts";
  export default TableConfig;
</script>